import React from "react";
import {withTranslation} from 'react-i18next';
import {Col, Container, Form, Row} from "react-bootstrap";
import {compose, getAllModalFunctions, getDataFromModals} from "../../../utils";
import {withTLService} from "../../hoc";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import SettingTable from "../../modal-elements/setting-table";
import BaseModal from "../base-modal";


class ModalAddEditGroup extends BaseModal {

    render() {

        const {index} = this.props;
        const data = getDataFromModals(this.props, index);
        const {name, company_id} = data;

        const {
            t: translate,
            adminData: {companies, options},
        } = this.props;

        console.log('render modal');
        
        const settingsType = Object.keys(options).filter(v => options[v].level.indexOf('group') > -1).reduce((acc, key) => {
            acc[key] = options[key].type
            return acc
        }, {})

        return (
            <Container>
                <Row>
                    <Col md={6}>
                        <Form.Group controlId="company_id">
                            <Form.Control
                                onChange={e => this.handleChange(e)}
                                value={company_id}
                                name="company_id"
                                as="select">
                                <option key={0} value={0}>{translate("choose company")}</option>
                                {
                                    Object.keys(companies).length > 0 && Object.keys(companies).map((company) =>
                                        <option key={company}
                                                value={company}>{companies[company].name}</option>
                                    )
                                }
                            </Form.Control>
                        </Form.Group>
                    </Col>
                    <Col md={6}>
                        <Form.Group controlId="name">
                            <Form.Control
                                type="text"
                                name="name"
                                defaultValue={name}
                                onChange={e => this.handleChange(e)}
                                placeholder={translate("Enter name")}/>
                        </Form.Group>
                    </Col>
                </Row>

                <h1 className="h5 mb-0 text-gray-800 my-3">{translate("Options")}</h1>
                <SettingTable
                    addText='Add option'
                    settingText='Options'
                    valueText='Value'
                    valuePlaceholder='Add Value'
                    selectText='Select option name'
                    settings={Object.keys(options).filter(v => options[v].level.indexOf('group') > -1 && options[v].is_private === 0)}
                    settingFieldName='user_group_options'
                    settingsType = {settingsType}
                    {...this.props}
                />
            </Container>
        )
    }
}

const mapStateToProps = ({userData, modalData, openData, adminData}) => {
    return {userData, openData, modalData, adminData};
};

const mapDispatchToProps = (dispatch, {tlService}) => {
    return bindActionCreators({
        ...getAllModalFunctions(),
    }, dispatch);
};

export default compose(
    withTranslation(),
    withTLService(),
    connect(mapStateToProps, mapDispatchToProps)
)(ModalAddEditGroup);